import React from 'react';
import ModalBase from './ModalBase';
import {Button, Col, Row} from "react-bootstrap";

type Props = {
    show : boolean;
    handleShowNoEmailProvidedModal : (show : boolean) => void;
};

const NoEmailProvidedModal = ({show, handleShowNoEmailProvidedModal} : Props) => {
    const handleCloseModal = () => {
        handleShowNoEmailProvidedModal(false);
    };

    return (
        <ModalBase
            show={show}
            title=""
            size="lg"
            hideConfirmButton={true}
            hideCloseButton={true}
            handleClose={handleCloseModal}
        >
            <Row className="chris-form-bg mx-0 py-3 px-2">
                <Col xs={12}>
                    <h3>Error: No Email Provided</h3>
                    <p>Please enter an email in "SEND EMAIL TO" before clicking the "Email Link"</p>
                </Col>
            </Row>
            <Col xs={12}><hr /></Col>
            <Row className="mx-0 mt-2">
                <Col xs={12} className="d-flex flex-row justify-content-start justify-content-lg-end">
                    <Button
                        variant="outline-secondary"
                        type="button"
                        className="d-flex pt-2 flex-row align-content-center mr-2"
                        onClick={async () => {
                            handleCloseModal();
                        }}
                    >Close</Button>
                </Col>
            </Row>
        </ModalBase>
    );
};

export default NoEmailProvidedModal;